import styled from 'styled-components'

export const DragAndDrop = styled.div`
  button {
    padding: 0 13px;
    color: #757575 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
`

export const TableHeader = styled.div`
  margin-top: 16px;
  font-size: 12px;
  font-weight: bold;
  color: #808080;
  .ant-col {
    padding: 10px 0;
    padding-right: 13px;
    border-bottom: 1px solid #d9d9d9;
  }
`

export const TableBody = styled.div`
  font-size: 14px;
  color: #363636;
  .ant-col {
    padding: 10px 0;
    padding-right: 13px;
    border-bottom: 1px solid #d9d9d9;
    line-height: 30px;
    input {
      padding: 4px 5px 4px 11px;
    }
  }
`

export const Question = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Options = styled.div`
  button {
    background-color: #f0f0f0 !important;
    color: #4c4c4c !important;
    border: none;
    border-radius: 8px;
    padding: 0 14px;
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
`
